
import React from 'react'
import {Redirect} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import {environment, subdomainResource} from '../../helpers/url'

const domains = {
  development: 'http://localhost:8896',
  staging: `//${subdomainResource('staging-grading')}`,
  production: `//${subdomainResource('grading')}`
}
const domain = domains[environment] || domains.development

function makeGradingUrl (languageId, path) {
  return `${domain}/#/${languageId}/${path}`
}

const useStyles = makeStyles(gradingStyles)

export default function Grading ({context}) {

  const classes = useStyles()
  const {profile, grading, languageId} = context
  const {periods, summaries} = grading
  const {project} = profile.institution

  const loading = (!periods.initialized && periods.loading) || (!summaries.initialized && summaries.loading)
  if (loading) return (<Loader />)

  const pendingSchoolYearSetup = !periods.currentYear

  let src = ''

  if (pendingSchoolYearSetup && project == 'homescholer') src = makeGradingUrl(languageId, 'periods/create-periods')
  else if (pendingSchoolYearSetup)  src = makeGradingUrl(languageId, 'pending-setup')
  else src = makeGradingUrl(languageId, `book/${periods.currentYear.id}`)

  return (
    <Box className={classes.root}>
      <iframe className={classes.iframe} src={src}></iframe>
    </Box>
  )

}

function Loader () {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  )
}

function gradingStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      margin: 20,
      padding: 0,
      backgroundColor: '#fff',
      color: '#4f576e',
    },
    iframe: {
      flexGrow: 1,
      border: 0
    }
  }
}
